export default [
  {
    header: 'Генератор',
    resource: 'generator',
    action: 'view',
  },
  {
    title: 'Пакеты',
    route: 'generator-packs',
    icon: 'PackageIcon',
    resource: 'generator',
    action: 'view',
  },
  {
    title: 'Оплаты',
    route: 'generator-payments',
    icon: 'CreditCardIcon',
    resource: 'generator-payments',
    action: 'view',
  },
]
